import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "voerro-notification-theme-white-orange notif-hide"
}

import { watch } from "vue";
import { EventsEnum } from "@/utils/enum/general/eventsEnum";
import { useEventsBus } from "@/composition/event/useEventBus";
import ChatNotification from "@/components/views/chat/ChatNotification.vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { ContentMediaTypeEnum } from "@/utils/enum/chat/message/contentMediaTypeEnum";
import { AppNotification } from "@/types/notification/AppNotification";
import AppNotificationCard from "@/components/common/notifications/AppNotificationCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNotificationsContainer',
  setup(__props) {

const { bus } = useEventsBus();
const { t } = useI18n();
const toast = useToast();

watch(
  () => bus.value.get(EventsEnum.RECEIVE_MESSAGE_NOTIFICATION),
  (
    value: {
      text: string;
      sentAt: string;
      chatRoomId: string;
      userAvatar: string | null;
      userName: string | null;
      userSurname: string | null;
      contentMediaType: ContentMediaTypeEnum;
    }[]
  ) => {
    const content = {
      component: ChatNotification,
      props: {
        notification: value[0],
      },
    };
    toast(content, {
      id: value[0].chatRoomId,
      toastClassName: "my-custom-toast",
    });
  }
);

watch(
  () => bus.value.get(EventsEnum.RECEIVE_APP_NOTIFICATION),
  (value: [{ notification: AppNotification }]) => {
    const content = {
      component: AppNotificationCard,
      props: {
        notification: value[0].notification,
        t: t,
      },
    };
    toast(content, {
      id: value[0].notification.id,
      toastClassName: "my-custom-toast",
    });
  }
);

watch(
  () => bus.value.get(EventsEnum.USER_CHANGED_CHAT),
  (
    value: {
      chatRoomId: string;
    }[]
  ) => {
    toast.dismiss(value[0].chatRoomId);
  }
);

return (_ctx: any,_cache: any) => {
  return false
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("hide")), 1))
    : _createCommentVNode("", true)
}
}

})